var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHqIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_487_4457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.5 1.5H4.5C2.84315 1.5 1.5 2.84315 1.5 4.5V43.5C1.5 45.1569 2.84315 46.5 4.5 46.5H43.5C45.1569 46.5 46.5 45.1569 46.5 43.5V4.5C46.5 2.84315 45.1569 1.5 43.5 1.5Z",
    stroke: "#2A364E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 7.5H9M39 7.5H42M39 40.5H42M6 40.5H9M21 16.5V31.5M12 31.5V16.5M12 24H21",
    stroke: "#2A364E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5 22.5C34.5 20.0147 32.4853 18 30 18C27.5147 18 25.5 20.0147 25.5 22.5V25.5C25.5 27.9853 27.5147 30 30 30C32.4853 30 34.5 27.9853 34.5 25.5V22.5Z",
    stroke: "#2A364E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 28.5C33 28.8978 33.158 29.2794 33.4393 29.5607C33.7206 29.842 34.1022 30 34.5 30H37.5",
    stroke: "#2A364E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_487_4457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHqIcon);
export default __webpack_public_path__ + "static/media/hqIcon.8e1dad11110d96fe0a4e8fa245981b01.svg";
export { ForwardRef as ReactComponent };